import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from './store/configure';

import Leads from './leads';
import {
  COLUMN_DEFINITIONS,
  CONFIGURABLE_COLUMNS,
  LAST_UPDATED
} from './table/cell';

import './styles.scss';

export default class LeadsIndex extends React.Component {
  static propTypes = {
    availableDatabaseOptions: PropTypes.array.isRequired,
    brokers: PropTypes.array.isRequired,
    clientReportActive: PropTypes.bool.isRequired,
    companies: PropTypes.array.isRequired,
    currentUser: PropTypes.object.isRequired,
    defaultTaskAssignee: PropTypes.object.isRequired,
    features: PropTypes.shape({
      projectTasksActivities: PropTypes.bool.isRequired
    }),
    leadReferralSources: PropTypes.array.isRequired,
    leadStatuses: PropTypes.array.isRequired,
    paths: PropTypes.object.isRequired,
    properties: PropTypes.array.isRequired,
  };

  store = configureStore({
    availableDatabaseOptions: this.props.availableDatabaseOptions,
    currentUser: this.props.currentUser,
    defaultTaskAssignee: this.props.defaultTaskAssignee,
    features: this.props.features,
    paths: this.props.paths,
    query: {
      leadReferralSources: this.props.leadReferralSources,
      leadStatuses: this.props.leadStatuses,
      properties: this.props.properties,
      companies: this.props.companies,
      brokers: this.props.brokers,
      page: 1,
      // columnKey is needed to help the table compare old and new sort keys on change
      // TODO: quick fix: store columnKey here - should be at top level
      sort: { columnKey: LAST_UPDATED, column: COLUMN_DEFINITIONS[LAST_UPDATED].sortValue, order: 'desc' },
      searchText: '',
      brokerFilter: [],
      referralSourceFilter: [],
      statusFilter: [],
      waitlistFilter: [],
      profileUserTypeFilter: [],
      propertyFilter: [],
      caStatusFilter: [],
      companyFilter: [],
      startDate: null,
      endDate: null
    },
    search: {
      leads: [],
      isFetching: true,
      meta: {
        currentPage: 0,
        pageSize: 25,
        totalCount: 0,
        totalPages: 0
      }
    },
    session: {
      currentColumns: CONFIGURABLE_COLUMNS
    },
    ui: {
      alertMessage: '',
      error: false,
      lead: null,
      showModal: false,
      showModalAlert: false,
      showTaskModal: false,
      showAllFiltersModal: false,
    }
  });

  render() {
    return (
      <Provider store={this.store}>
        <Leads clientReportActive={this.props.clientReportActive} defaultColumns={CONFIGURABLE_COLUMNS} />
      </Provider>
    );
  }
}
